export default "__VITE_ASSET__Dg1OTxGi__"